import { Box, Card, CardContent, CardHeader, Table, TableBody, TableCell, TableHead, TableRow, TextField, Typography, Tooltip, IconButton } from "@mui/material";
import { generateClient } from "aws-amplify/api";
import moment from "moment";
import { useContext, useEffect, useState } from "react";
import { UserContext } from "../../contexts/UserContext";
import { esQuery } from "../../graphql/queries";
import { cardStyle } from "../../theme";
import { KeyboardArrowDownOutlined, KeyboardArrowUpOutlined, RefreshOutlined } from "@mui/icons-material";


export default function ManualDialDashboard(props) {
    const client = generateClient();
    const userContext = useContext(UserContext);
    const [date, setDate] = useState(moment().format('YYYY-MM-DD'));

    const [total, setTotal] = useState(0);
    const [activeCalls, setActiveCalls] = useState(0);
    const [dispositioning, setDispositioning] = useState(0);
    const [agentDispositions, setAgentDispositions] = useState([]);
    const [refreshTime, setRefreshTime] = useState();

    useEffect(() => {
        getData();

    }, []);

    useEffect(() => {
        getData();
    }, [props.skillId, date]);

    function getCallHistoryQuery() {
        const query = {
            "aggs": {
                "disposition": {
                    "terms": {
                        "field": "disposition.keyword",
                        "size": 2147483647
                    },
                    "aggs": {
                        "agent": {
                            "terms": {
                                "field": "agent.keyword",
                                "size": 2147483647
                            }
                        }
                    }
                }
            },
            "query": {
                "bool": {
                    "must": [
                        {
                            "term": {
                                "tenant.keyword": userContext.tenantId
                            }
                        },
                        {
                            "match_phrase": {
                                "type": "Dial"
                            }
                        },
                        {
                            "match_phrase": {
                                "title": "Manual Dial"
                            }
                        },
                        {
                            "range": {
                                "createdAt": {
                                    "gte": moment(date).startOf('day').toISOString(),
                                    "lte": moment(date).endOf('day').toISOString()
                                }
                            }
                        }
                    ]
                }
            },
            "size": 0
        }

        if (props.skillId) {
            query.query.bool.must.push({
                "match_phrase": {
                    "metaData.skillId": props.skillId
                }
            });
        }

        return query;
    }

    async function getData() {
        const dataResponse = await client.graphql({
            query: esQuery,
            variables: {
                model: 'activitylog-*',
                action: '_search',
                query: JSON.stringify(getCallHistoryQuery())
            }
        });

        const results = JSON.parse(dataResponse.data.esQuery);

        setTotal(results.hits.total);

        const agentDispositionsResults = [];

        for (const disposition of results.aggregations.disposition.buckets) {

            if (disposition.agent.buckets.length > 0) {
                for (const agent of disposition.agent.buckets) {
                    const existingAgent = agentDispositionsResults.find(a => a.agent === agent.key);
                    if (existingAgent) {
                        existingAgent.count += agent.doc_count;
                        existingAgent.dispositions.push({ disposition, count: existingAgent.count });
                    } else {
                        agentDispositionsResults.push({ agent: agent.key, count: agent.doc_count, dispositions: [{ disposition, count: agent.doc_count }] });
                    }
                }
            }
        }

        setAgentDispositions(agentDispositionsResults);
        setRefreshTime(new Date().toLocaleTimeString("en-US", { hour: '2-digit', minute: '2-digit', second: '2-digit' }));
    }

    function GetRow({ agent }) {
        const [open, setOpen] = useState(false);

        return (
            <>
                <TableRow key={agent.agent} onClick={() => {
                    setOpen(!open);
                }}>
                    <TableCell>{open ? <KeyboardArrowUpOutlined /> : <KeyboardArrowDownOutlined />}</TableCell>
                    <TableCell>
                        {agent.agent}
                    </TableCell>
                    <TableCell align="right">{agent.count}</TableCell>
                    <TableCell align="right">{((agent.count / total) * 100).toFixed(2)}%</TableCell>

                </TableRow>
                <TableRow sx={{ display: open ? 'table-row' : 'none' }}>
                    <TableCell colSpan={4} sx={{ paddingBottom: 0, paddingTop: 0 }}>
                        <Table size="small" aria-label="dispositions">
                            <TableHead>
                                <TableRow>
                                    <TableCell>Disposition</TableCell>
                                    <TableCell align="right">Count</TableCell>
                                    <TableCell align="right">Percentage</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {agent.dispositions.map((disposition) => (
                                    <TableRow key={disposition.disposition.key}>
                                        <TableCell>
                                            {disposition.disposition.key}
                                        </TableCell>
                                        <TableCell align="right">{disposition.count}</TableCell>
                                        <TableCell align="right">{((disposition.count / agent.count) * 100).toFixed(2)}%</TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableCell>
                </TableRow>
            </>
        );
    }

    return (
        <>
            <Card variant="outlined" sx={cardStyle}>
                <CardHeader title={props.skillId ? `Manual Dialing for ${props.profileName}` : `Manual Dialing`} action={
                    <TextField
                        type="date"
                        value={date}
                        onChange={(e) => setDate(e.target.value)}
                    />
                }
                    subheader={
                        <Box display="flex" alignItems="center" gap={1}>
                            <Typography variant="subtitle2">{refreshTime}</Typography>
                            <Tooltip title="Refresh"><IconButton onClick={() => getData()}><RefreshOutlined color="primary" /></IconButton></Tooltip>
                        </Box>
                    }
                />

                <CardContent>
                    <Box display="flex" flexDirection="column" gap={2}>
                        <Box display="flex" gap={2}>
                            <Card variant="outlined" sx={cardStyle}>
                                <CardContent>
                                    <Box display="flex" sx={{ height: '100%' }} justifyContent="center" flexDirection="column" alignItems="center" >
                                        <Typography variant="h2">{total}</Typography>
                                        <Typography variant="h6">Total Manual Calls</Typography>
                                    </Box>
                                </CardContent>
                            </Card>
                            {/* <Card variant="outlined" sx={cardStyle}>
                                <Box display="flex" sx={{ height: '100%' }} flexDirection="column" alignItems="center" justifyContent="center" >
                                    <Typography variant="h2">{activeCalls}</Typography>
                                    <Typography variant="h6">Active Calls</Typography>
                                    <Button disabled={activeCalls < 1} onClick={() => setShowActiveCalls(true)}>View Calls</Button>
                                </Box>
                            </Card>
                            <Card variant="outlined" sx={cardStyle}>
                                <Box display="flex" sx={{ height: '100%' }} justifyContent="center" flexDirection="column" alignItems="center" >
                                    <Typography variant="h2">{dispositioning}</Typography>
                                    <Typography variant="h6">Dispositioning</Typography>
                                </Box>
                            </Card> */}
                        </Box>
                        <Card variant="outlined" sx={cardStyle}>
                            <CardContent>
                                <Table size="small">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell></TableCell>
                                            <TableCell>Agent</TableCell>
                                            <TableCell align="right">Count</TableCell>
                                            <TableCell align="right">Percentage</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {agentDispositions.map((agent) => (
                                            <GetRow agent={agent} />
                                        ))}
                                    </TableBody>
                                </Table>
                            </CardContent>
                        </Card>
                    </Box>
                </CardContent>
            </Card >
        </>
    )

}